import {PagedData} from "@/services/models/shared/PagedData";
import {AxiosResponse} from "axios";
import {
    GeneralCode,
    GeneralCodeEntity,
    GeneralCodeEntityFilterOptions,
    GeneralCodeFilterOptions,
    GeneralCodeListItem,
    NewGeneralCode,
    UpdateGeneralCode
} from "@/services/models/GeneralCode";
import BimsHttpService from "@/services/BimsHttpService";

class GeneralCodeService {
    /**
     * @description Returns a paged list of general codes.
     */
    getGeneralCodeList(filter: GeneralCodeFilterOptions
    ): Promise<PagedData<GeneralCodeListItem>> {
        return BimsHttpService.get(`/generalCodes`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<GeneralCodeListItem>>) => {
            return response.data as PagedData<GeneralCodeListItem>;
        });
    }

    /**
     * @description Returns the general code with the specified id
     */
    getGeneralCode(id: number): Promise<GeneralCode> {
        return BimsHttpService.get(`/generalCodes/${id}`).then((response: AxiosResponse<GeneralCode>) => {
            return response.data as GeneralCode;
        });
    }

    /**
     * @description Returns the list of general code entities that start with the entity name
     */
    getEntities(filter: GeneralCodeEntityFilterOptions): Promise<PagedData<GeneralCodeEntity>> {
        return BimsHttpService.get(`/generalCodes/entities`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<GeneralCodeEntity>>) => {
            return response.data as PagedData<GeneralCodeEntity>;
        });
    }

    /**
     *  @description Adds a new general code
     */
    addGeneralCode(generalCode: NewGeneralCode): Promise<any> {
        return BimsHttpService.post(`/generalCodes`,
            generalCode
        );
    }

    /**
     * @description Updates the general code
     */
    updateGeneralCode(generalCode: UpdateGeneralCode): Promise<any> {
        return BimsHttpService.put(`/generalCodes/${generalCode.id}`,
            generalCode
        )
    }
}

export default new GeneralCodeService()
